export interface FormValues {
  comments: string;
}
export default function mapPropsToValues() {
  return {
    comments: "",
  };
}
